import { handleActions } from "redux-actions";
import { ACTIONS } from "./actions";

const initialState: AboutState = {
	checkLicense: {
		success: null,
		error: null,
		loading: false,
	},
	refreshLicense: {
		success: null,
		error: null,
		loading: false,
	},
};

export default handleActions(
	{
		[`${ACTIONS.CHECK_LICENSE}_PENDING`]: (state) => ({
			...state,
			checkLicense: {
				...state.checkLicense,
				loading: true,
			},
		}),
		[`${ACTIONS.CHECK_LICENSE}_REJECTED`]: (state, action) => ({
			...state,
			checkLicense: { success: null, error: action.payload, loading: false },
		}),
		[`${ACTIONS.CHECK_LICENSE}_FULFILLED`]: (state, action) => ({
			...state,
			checkLicense: { success: action.payload, error: null, loading: false },
		}),
		[`${ACTIONS.REFRESH_LICENSE}_PENDING`]: (state) => ({
			...state,
			refreshLicense: {
				...state.refreshLicense,
				loading: true,
			},
		}),
		[`${ACTIONS.REFRESH_LICENSE}_REJECTED`]: (state, action) => ({
			...state,
			refreshLicense: { success: null, error: action.payload, loading: false },
		}),
		[`${ACTIONS.REFRESH_LICENSE}_FULFILLED`]: (state, action) => ({
			...state,
			refreshLicense: { success: action.payload, error: null, loading: false },
			checkLicense: { success: action.payload, error: null, loading: false },
		}),
		[ACTIONS.RESET_REFRESH_LICENSE]: (state) => ({
			...state,
			refreshLicense: {
				success: null,
				error: null,
				loading: false,
			},
		}),
	},
	initialState
);

export interface AboutState {
	checkLicense: any;
	refreshLicense: any;
}
